import React from 'react';
import TransportationManagement from '../../components/TransportationManagement';

const TransportationManagementPage = () => {
  return <TransportationManagement />;
};

export default TransportationManagementPage;